import { useContext } from 'react';
import { OrganizeItemsContext } from './OrganizeItemsContext';

export const useOrganizeItemsContext = () => {
  const context = useContext(OrganizeItemsContext);

  if (context === undefined) {
    throw new Error('useOrganizeItems must be used within a AppealContextProvider');
  }

  return context;
};
